export default "It's an alien!"